import {PlusOutlined} from '@ant-design/icons';
import {Badge, Button, Form} from 'antd';
import React, {FC, memo} from 'react';

import {
    useAutoAddOnEmpty
} from '../../hooks/use-auto-add-on-empty';
import {InvestorsItem} from './investors-item';

interface IFinancialSourcesInnerProps {
    fields: any[];
    add: () => void;
    remove: (index: number) => void;
}

const InvestorsListInner = memo<IFinancialSourcesInnerProps>(
    ({fields, add, remove} : IFinancialSourcesInnerProps) => {

    const {handleAdd} = useAutoAddOnEmpty(fields.length, add);

    return (
        <>
            <Badge count={fields.length} className="add-project-badge">
                <Button
                    type="primary"
                    onClick={handleAdd}
                    icon={<PlusOutlined />}
                    className="add-project-button"
                >
                    Добавить инвестора
                </Button>
            </Badge>
            {fields.map((field) => (
                <InvestorsItem
                    key={field.key}
                    field={field}
                    onRemove={remove}
                />
            ))}
        </>
    );
});

export const InvestorsList: FC = () => (
    <div
        className="form-flex"
        style={{
            maxHeight: 'calc(min(600px, 64vh))',
            overflow: 'auto',
            paddingRight: 8,
            width: '100%',
        }}
    >
        <Form.List name="investors">
            {(fields, {add, remove}) => (
                <InvestorsListInner
                    fields={fields}
                    add={add}
                    remove={remove}
                />
            )}
        </Form.List>
    </div>
);
